import { render } from "./MultilingualTextarea.vue?vue&type=template&id=65e6afd2&scoped=true"
import script from "./MultilingualTextarea.vue?vue&type=script&lang=js"
export * from "./MultilingualTextarea.vue?vue&type=script&lang=js"

import "./MultilingualTextarea.vue?vue&type=style&index=0&id=65e6afd2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e6afd2"]])

export default __exports__